import { jsx as _jsx } from "react/jsx-runtime";
import { ItemType } from "sprout-graphql";
import { useMemo } from "react";
import { NavigationBreadcrumbs as BaseNavigationBreadcrumbs } from "@sprout/client-components/dist/Navigation";
import styled from "styled-components";
import { themeGet } from "sprout-ui-theme";
const NavigationBreadcrumbs = styled(BaseNavigationBreadcrumbs)`
  border-radius: 30px;
  background: ${themeGet("colors.white.100")};
  padding-left: 16px;
  padding-right: 16px;
`;
const PostPageNavigationBreadcrumbs = (props)=>{
    const { breadcrumbsList: breadcrumbsListProp , owner  } = props;
    const breadcrumbsList = useMemo(()=>{
        return [
            ...breadcrumbsListProp || []
        ].filter((breadcrumbItem)=>breadcrumbItem.__typename === "Item" && breadcrumbItem.type === ItemType.Topic).reverse();
    }, [
        breadcrumbsListProp
    ]);
    return /*#__PURE__*/ _jsx(NavigationBreadcrumbs, {
        owner: owner,
        breadcrumbsList: breadcrumbsList
    });
};
export default PostPageNavigationBreadcrumbs;
